var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29_1308)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.072,
    cy: 62.072,
    r: 44.072,
    fill: "#0156F9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5504 71.8581C95.491 68.435 96.9235 64.0695 96.5817 59.5682C96.2399 55.067 94.1665 50.9678 90.7434 48.0273C87.3203 45.0868 82.9573 43.6542 78.4561 43.996C74.6007 44.2876 71.0444 45.8533 68.2547 48.447C69.2399 49.8218 70.0542 51.3071 70.6875 52.8704C72.7786 50.4979 75.6588 49.0577 78.8205 48.819C82.0324 48.5752 85.1489 49.5981 87.5918 51.6967C90.0347 53.7953 91.515 56.7207 91.7588 59.9352C92.0025 63.1471 90.9796 66.2636 88.8811 68.7065C86.7825 71.1493 83.8571 72.6297 80.6426 72.8734C74.0051 73.3761 68.2044 68.3898 67.7018 61.7573L67.546 59.709C67.2042 55.2077 65.1307 51.1086 61.7077 48.1681C58.2871 45.2275 53.919 43.795 49.4203 44.1368C44.919 44.4786 40.8199 46.552 37.8794 49.9751C34.9389 53.3982 33.5063 57.7637 33.8481 62.265C34.1321 66.0022 35.6124 69.4579 38.0629 72.2074L37.1882 79.9986L45.002 76.9047C46.8065 77.5506 48.7166 77.8874 50.6694 77.8874C51.1017 77.8874 51.5365 77.8698 51.9738 77.8372C55.8316 77.5456 59.3929 75.9748 62.1852 73.3761C61.21 72.0164 60.3882 70.5361 59.7448 68.9578C57.6538 71.3353 54.771 72.7754 51.6068 73.0142C48.3949 73.258 45.2784 72.2351 42.8355 70.1365C40.3927 68.0379 38.9123 65.1125 38.6686 61.898C38.4248 58.6861 39.4477 55.5696 41.5462 53.1267C43.6448 50.6838 46.5703 49.2035 49.7847 48.9597C52.9992 48.7159 56.1131 49.7388 58.556 51.8374C60.9989 53.936 62.4792 56.8614 62.723 60.0759L62.8788 62.1242C63.5499 70.9835 70.9741 77.7467 79.7177 77.7467C80.145 77.7467 80.5747 77.7316 81.007 77.6989C82.4672 77.5883 83.8822 77.2918 85.2318 76.8293L93.2366 79.9986L92.3494 72.0767C92.4147 72.0039 92.4826 71.9335 92.5479 71.8581H92.5504Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29_1308",
    x: 0.433056,
    y: 0.371191,
    width: 129.278,
    height: 129.278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.93813
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.2835
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.227451 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29_1308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29_1308",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33605ba51e8e195c19cc0de1f87d0f2d.svg";
export { ForwardRef as ReactComponent };